/**
 * @file 入口函数
 * @author  fangsimin
 * @date    2019-01-02 13:25:50
 * @last Modified by    fangsimin
 * @last Modified time  2019-01-14 19:54:51
 */

import Vue from 'vue';
import '@/plugins/element.js';
import router from './router';
import '@/plugins/ajax.js';
// import '@/plugins/devtoolsDetect.js';
// import '@/plugins/fontawesome.js'; // icon使用fontawesome
import i18n from '@/i18n/i18n';
import store from '@/store';
import filter from '@/common/vue-filter';

import VueXss from 'vue-xss';
Vue.use(VueXss, {
    whiteList: {
        div: ['data-oembed-url', 'style'],
        video: ['width', 'height', 'style', 'controls'],
        source: ['src', 'type'],
        a: ['class', 'href', 'target', 'download', 'type', 'style'],
        table: ['class', 'style', 'border', 'cellspacing', 'cellpadding'],
        tbody: ['class', 'style'],
        tr: ['class', 'style'],
        td: ['class', 'style', 'rowspan', 'colspan'],
        img: ['class', 'src', 'width', 'alt', 'style'],
        blockquote: ['class', 'style'],
        code: [],
        h1: ['style', 'class'],
        h2: ['style', 'class'],
        h3: ['style', 'class'],
        h4: ['style', 'class'],
        h5: ['style', 'class'],
        p: ['style', 'class'],
        ul: ['style', 'class'],
        ol: ['style', 'class'],
        li: ['style', 'class'],
        span: ['style', 'class'],
        i: ['style', 'class'],
        s: ['style', 'class'],
        thead: ['style', 'class'],
        th: ['style', 'class'],
        u: ['style', 'class'],
        br: [],
        strong: ['style', 'class'],
        figcaption: ['style', 'class'],
        figure: ['style', 'class']
    },
    stripIgnoreTagBody: ['script', 'style']
});
// import VueAwesomeSwiper from 'vue-awesome-swiper';

// import 'swiper/swiper-bundle.css';
// Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;
Object.keys(filter).forEach(key => {
    Vue.filter(key, filter[key]);
});
Vue.directive('clickoutside', {
    bind(el, binding, vnode) {
        function documentHandler(e) {
            if (el.contains(e.target)) {
                return false;
            }
            if (binding.expression) {
                binding.value(e);
            }
        }
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
    },
    unbind(el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
    }
});

new Vue({
    store,
    i18n,
    router
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js